/**
 * gat-flower-quick-edit.js
 * Flower weight conversion + stock rules for:
 *  - Cart Edit Modal
 *  - Product Quick View
 */

(function () {
  'use strict';

  const MULTIPLIERS = {
    '3.5 grams': 1,
    '7 grams': 2,
    '14 grams': 4,
    '28 grams': 8
  };

  const productCache = {};

  function getSelectedWeight(container) {
    const root = container || document;

    let el = root.querySelector('input[name="Weight"]:checked');
    if (el) return el.value.trim();

    el = root.querySelector('input[type="radio"]:checked');
    if (el && el.value && el.value.indexOf('grams') !== -1) return el.value.trim();

    el = root.querySelector('.option-swatch-js.active, .option-swatch-js[aria-checked="true"]');
    if (el) {
      return (el.dataset.value || el.getAttribute('data-value') || el.textContent).trim();
    }

    el = root.querySelector('[data-value].active, .swatch.active, .product__item-option.active, label.active');
    if (el) {
      return (el.dataset.value || el.getAttribute('data-value') || el.textContent).trim();
    }

    el = root.querySelector('.swatch-selected-value, .option_value, .swatch-attribute-selected');
    if (el) return el.textContent.trim();

    return null;
  }

  function getProductUrl(modal) {
    const el = modal.querySelector('[data-url]');
    if (el && el.getAttribute('data-url')) return el.getAttribute('data-url');
    return null;
  }

  function findBaseFromVariants(variants) {
    if (!Array.isArray(variants)) return null;

    var base = variants.find(function (v) {
      return (
        (v.title && v.title.indexOf('3.5 grams') !== -1) ||
        (v.option1 && v.option1.indexOf('3.5 grams') !== -1) ||
        (v.option && String(v.option).indexOf('3.5 grams') !== -1) ||
        (v.options && v.options.join(' ').indexOf('3.5 grams') !== -1)
      );
    });

    if (!base) return null;

    var inventory = null;
    if (base.inventory_quantity != null) inventory = base.inventory_quantity;
    else if (base.qty != null) inventory = base.qty;

    return {
      id: base.id,
      inventory: inventory
    };
  }

  function getBaseVariantData(modal, callback) {
    var baseId = null;
    var inventoryFromJson = null;

    var jsonScripts = modal.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < jsonScripts.length; i++) {
      try {
        var parsed = JSON.parse(jsonScripts[i].textContent);
        var found = findBaseFromVariants(parsed);
        if (found && found.id) {
          baseId = found.id;
          if (found.inventory != null && found.inventory !== '') {
            inventoryFromJson = parseInt(found.inventory, 10);
          }
        }
      } catch (e) {}
    }

    if (!baseId && window.GAT_FLOWER_BASE_VARIANT_ID) {
      baseId = window.GAT_FLOWER_BASE_VARIANT_ID;
      if (window.GAT_FLOWER_INVENTORY != null) {
        inventoryFromJson = parseInt(window.GAT_FLOWER_INVENTORY, 10);
      }
    }

    var productUrl = getProductUrl(modal);

    if (productUrl && productCache[productUrl]) {
      callback(productCache[productUrl]);
      return;
    }

    if (productUrl) {
      fetch(productUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var fromProduct = findBaseFromVariants(product.variants || []);
          var result = {
            id: (fromProduct && fromProduct.id) || baseId,
            inventory: (fromProduct && fromProduct.inventory != null)
              ? fromProduct.inventory
              : (inventoryFromJson != null ? inventoryFromJson : 0)
          };
          if (result.id) productCache[productUrl] = result;
          callback(result.id ? result : null);
        })
        .catch(function () {
          if (!baseId) {
            callback(null);
            return;
          }
          callback({
            id: baseId,
            inventory: inventoryFromJson != null ? inventoryFromJson : 0
          });
        });
      return;
    }

    if (!baseId) {
      callback(null);
      return;
    }

    callback({
      id: baseId,
      inventory: inventoryFromJson != null ? inventoryFromJson : 0
    });
  }

  function getAvailableStock(base, callback) {
    const inventory = parseInt(base.inventory, 10) || 0;
    const baseId = Number(base.id);

    fetch('/cart.json')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === baseId) inCart += item.quantity;
        });
        callback(Math.max(0, inventory - inCart));
      })
      .catch(function () {
        callback(inventory);
      });
  }

  function updateWeightAvailability(modal, available) {
    modal.querySelectorAll('input[name="Weight"]').forEach(function (input) {
      var weight = input.value.trim();
      var needed = MULTIPLIERS[weight];
      if (!needed) return;

      var disabled = available < needed;
      input.disabled = disabled;
      input.classList.toggle('option-disabled', disabled);
    });

    modal.querySelectorAll('.option-swatch-js[data-value]').forEach(function (el) {
      var weight = (el.dataset.value || el.getAttribute('data-value') || '').trim();
      var needed = MULTIPLIERS[weight];
      if (!needed) return;

      var disabled = available < needed;
      el.classList.toggle('option-disabled', disabled);
      el.style.pointerEvents = disabled ? 'none' : '';
    });
  }

  function refreshModalAvailability(modal) {
    getBaseVariantData(modal, function (base) {
      if (!base || !base.id) return;
      getAvailableStock(base, function (available) {
        updateWeightAvailability(modal, available);
      });
    });
  }

  function isInsideQuickContext(el) {
    return !!(
      el.closest('#product-form-quick-edit') ||
      el.closest('product-form-quick-edit') ||
      el.closest('.product-quickview__content') ||
      el.closest('[data-template-quick-cart-edit]') ||
      el.closest('.tingle-modal') ||
      el.closest('[data-section="product-quickview"]') ||
      el.closest('.product-quickview')
    );
  }

  function getModal(el) {
    return el.closest('.tingle-modal') ||
           el.closest('.product-quickview') ||
           el.closest('#product-form-quick-edit') ||
           el.closest('product-form-quick-edit') ||
           document;
  }

  function syncCartUi(cart) {
    if (!cart || cart.item_count === undefined) return;

    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.innerHTML = '(' + cart.item_count + ')';
      } else {
        el.innerHTML = cart.item_count > 100 ? '~' : cart.item_count;
      }
    });

    if (document.querySelector('header-total-price') && typeof document.querySelector('header-total-price').updateTotal === 'function') {
      document.querySelector('header-total-price').updateTotal(cart);
    }

    var bar = document.querySelector('free-ship-progress-bar');
    if (bar && typeof bar.init === 'function') {
      bar.init(cart.items_subtotal_price);
    }
  }

  function replaceMinicartForm(sectionHtml) {
    if (!sectionHtml) return;
    var current = document.getElementById('minicart-form');
    if (!current) return;
    var html = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var neu = html.querySelector('#minicart-form');
    if (neu) current.innerHTML = neu.innerHTML;
  }

  function getCartNotification() {
    return document.querySelector('cart-notification');
  }

  function isMinicartOpen() {
    var wrapper = document.querySelector('#minicart_wrapper .minicart__wrapper');
    return !!(wrapper && wrapper.classList.contains('open'));
  }

  function openMinicart() {
    var note = getCartNotification();
    if (!note || typeof note.open !== 'function') return;
    if (isMinicartOpen()) return;
    note.open();
  }

  function closeQuickView() {
    var closeBtn = document.querySelector(
      '.tingle-modal__close, .tingle-modal .close, [data-close], .product-quickview__close'
    );
    if (closeBtn) closeBtn.click();
  }

  function handleAddToCart(e) {
    if (!isInsideQuickContext(e.target)) return;

    const modal = getModal(e.target);
    const weight = getSelectedWeight(modal);
    if (!weight || !MULTIPLIERS[weight]) return;

    const multiplier = MULTIPLIERS[weight];

    e.preventDefault();
    e.stopImmediatePropagation();

    getBaseVariantData(modal, function (base) {
      if (!base || !base.id) return;

      const form = e.target.closest('form');
      let qtyInput = form ? form.querySelector('input[name="quantity"], .quantity-input, [name="quantity"]') : null;
      const currentQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      const finalQty = currentQty * multiplier;

      getAvailableStock(base, function (available) {
        if (finalQty > available) {
          alert('Only ' + available + ' x 3.5g left. That size needs ' + finalQty + '.');
          refreshModalAvailability(modal);
          return;
        }

        var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(base.id),
            quantity: finalQty,
            sections: ['minicart-form'],
            sections_url: window.location.pathname
          })
        })
        .then(function (res) { return res.text(); })
        .then(function (state) {
          var parsedState = JSON.parse(state);

          if (parsedState.sections && parsedState.sections['minicart-form']) {
            replaceMinicartForm(parsedState.sections['minicart-form']);
          }

          var note = getCartNotification();
          if (note && typeof note.cartAction === 'function') note.cartAction();

          closeQuickView();

          return fetch('/cart.json').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          syncCartUi(cart);
          openMinicart();
          refreshModalAvailability(modal);
          if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
        })
        .catch(function (err) {
          console.error('GAT Flower QuickEdit error:', err);
        });
      });
    });
  }

  function init() {
    const buttons = document.querySelectorAll(
      'button[name="add"], ' +
      'button.product-form__submit, ' +
      'button.product_submit_button, ' +
      '.product-form__submit'
    );

    buttons.forEach(function (btn) {
      if (isInsideQuickContext(btn)) {
        btn.removeEventListener('click', handleAddToCart, true);
        btn.addEventListener('click', handleAddToCart, true);

        const modal = getModal(btn);
        if (modal && modal !== document) refreshModalAvailability(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  const observer = new MutationObserver(function () {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();